import { type FC, type ReactNode } from 'react'
import { Typography } from 'shared/ui'

import styles from './styles.module.scss'

type IRcsExampleModalContentProps = {
  example: ReactNode
}

export const RcsExampleModalContent: FC<IRcsExampleModalContentProps> = ({ example }) => {
  return (
    <div className={styles.exampleModal}>
      <div className={styles.exampleModalText}>
        <Typography
          tag='div'
          ariaLabel='RcsExampleModalContent'
          variant='body-rg-regular'
          color='var(--content-primary-primary)'
        >
          {example}
        </Typography>
      </div>
    </div>
  )
}
